<div class="announcement">
  @for (category of displayedMessagesGrouped; track category; let categoryIndex = $index) {
    <h2
      class="announcement_header"
      [ngClass]="{ first_header: categoryIndex === 0 && !showTravelAdviceCondition }"
    >
      {{ category.categoryName }}
    </h2>
    <ul class="announcements_list">
      @for (ann of category.messages; track ann; let index = $index) {
        <li>
          <span
            class="message-text"
            [class.truncated]="
              ann?.config?.message?.length > messageTruncateLength &&
              !(ann.userCanSupress && !ann.clickToConfirm)
            "
            [class.truncated-single]="
              ann?.config?.message?.length > messageTruncateLength &&
              ann.userCanSupress &&
              !ann.clickToConfirm
            "
            [innerHTML]="ann?.config?.message | safeHtml: 'html'"
          ></span>
          @if (ann?.config?.messageLink) {
            <span class="message-link" i18n="@@announcementsMessageLink">
              Click
              <a target="_blank" tabindex="0" role="link" [href]="ann?.config?.messageLink">{{
                ann?.config?.messageLink
              }}</a>
              for more information
            </span>
          }
          @if (ann.clickToConfirm) {
            <div
              class="announcement_close"
              (click)="onDeleteAnnouncement(ann.id)"
              (keydown.enter)="onDeleteAnnouncement(ann.id)"
              attr.aria-label="Close {{ ann?.config?.message }} announcement"
              tabindex="0"
              role="button"
            >
              <i class="ico-cancel"></i>
            </div>
          }
          @if (ann.userCanSupress && !ann.clickToConfirm) {
            <div>
              <mat-checkbox
                (click)="onSuppressAnnouncement(ann.id)"
                class="light-accent"
                color="primary"
                [id]="checkboxId + '_' + index"
                i18n="@@suppressAnnouncement"
                aria-label="I have read the message, do not display again"
              >
                I have read the message, do not display again
              </mat-checkbox>
            </div>
          }
          @if (
            category.messages.length - 1 === index &&
            (totalMessageCount > category.messages.length ||
              ann?.config?.message?.length > messageTruncateLength)
          ) {
            <a
              class="continue-reading-link"
              (click)="openAllMessagesModal()"
              (keydown.enter)="openAllMessagesModal()"
              tabindex="0"
              i18n="@@continueReading"
              role="button"
              >...continue reading</a
            >
          }
        </li>
      }
    </ul>
  }
</div>
